export const allLanguages = ["fr", "en"] as const;
export type Language = (typeof allLanguages)[number];

export function isLanguage(lang: string | undefined): lang is Language {
  return allLanguages.includes(lang as Language);
}

export type LocalizedText = Record<Language, string>;

export const defaultLanguage: Language = "fr";
